import { render } from "./Language.vue?vue&type=template&id=06eee8f8&scoped=true&ts=true"
import script from "./Language.vue?vue&type=script&lang=ts"
export * from "./Language.vue?vue&type=script&lang=ts"

import "./Language.vue?vue&type=style&index=0&id=06eee8f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06eee8f8"]])

export default __exports__